export const ROUGHLY_EQUAL_THRESHOLD = 0.07;
export function roughlyEqual(
  a: number,
  b: number,
  threshold = ROUGHLY_EQUAL_THRESHOLD,
) {
  return Math.abs(a - b) < threshold;
}

export function getCommaSeparatedNumber(num?: number) {
  if (num === undefined) return "";

  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
